import type { NotificationConversationsProps } from '@/utils/hooks/context/toast/types';

// Components
import CommentPickerWinnerConfirmation from '@/components/composite/Notifications/Conversations/Comments/CommentPickerWinnerConfirmation';

const NotificationsConversations = ({ notification }: NotificationConversationsProps) => {
    const type = notification.type;
    switch (type) {
        case 'comment_picker_winner_confirmation':
            return <CommentPickerWinnerConfirmation notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsConversations;
